import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getNextInteraction } from '@chegg/commerce-utils';
import { captureError, Severity, TeamInfo } from '@chegg/observability';
import { useEffect, useState } from 'react';
import { authorize } from '../utils/checkoutAuthorization';
import { initApolloClient } from '../apollo/client';
import { USE_NEXT_INTERACTION_ERROR_LOCATION } from '../constants';
/**
 * Hook to get next action for a user based on their previous product and it's state.
 * Learn more: http://gce-document.test.cheggnet.com:1200/#next-interaction-api
 */
var useGetNextInteractionApi = function useGetNextInteractionApi(_ref) {
  var nextInteractionPayload = _ref.nextInteractionPayload,
    _ref$skip = _ref.skip,
    skip = _ref$skip === void 0 ? false : _ref$skip;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    data = _useState6[0],
    setData = _useState6[1];
  useEffect(function () {
    if (nextInteractionPayload && !skip) {
      setLoading(true);
      var _authorize = authorize(nextInteractionPayload.authorizeParams),
        success = _authorize.success;
      if (success) {
        getNextInteraction({
          request: nextInteractionPayload,
          apolloClient: initApolloClient(),
          teamName: TeamInfo['FT-Rigel'].name
        }).then(function (nextInteractions) {
          setData(nextInteractions);
        })["catch"](function (errorResponse) {
          var errors = (errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.errors) || [errorResponse];
          setError(errors);
          errors.forEach(function (err) {
            captureError({
              error: err,
              location: USE_NEXT_INTERACTION_ERROR_LOCATION,
              severity: Severity.ERROR
            }, {
              teamName: TeamInfo['FT-Rigel'].name
            });
          });
        })["finally"](function () {
          setLoading(false);
        });
      } else {
        setError([new Error('Authorization failed')]);
        setLoading(false);
      }
    }
  }, [nextInteractionPayload, skip]);
  return {
    data: data,
    error: error,
    loading: loading
  };
};
export default useGetNextInteractionApi;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/hooks/useGetNextGenerationApi.js
// module id = 5225
// module chunks = 11